import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CitiShopComponent } from './citi-shop.component';

export const routes: Routes = [
  {
    path: '',
    component: CitiShopComponent
  }
];
@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class CitiShopRoutingModule { }
